import { AccordionSummary, TableCell, TableRow } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

export const ExpandRowCell = muiStyled(TableCell)(({ theme }) => ({
  align: 'left',
  padding: 0,
  borderBottom: 'none',
  display: 'flex',
  width: '2%',
  marginRight: theme.spacing(2),
}));

export const StyledTableRow = muiStyled(TableRow)(() => ({
  height: '1rem',
  '&:hover': {
    cursor: 'pointer',
  },
}));

export const StyledAccordionSummary = muiStyled(AccordionSummary)(() => ({
  height: '48px',
  borderRadius: '4px',
}));
